import { render, staticRenderFns } from "./BranchSelectorDPD.vue?vue&type=template&id=72e57856&"
import script from "./BranchSelectorDPD.js?vue&type=script&lang=js&"
export * from "./BranchSelectorDPD.js?vue&type=script&lang=js&"
import style0 from "./BranchSelectorDPD.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports